import React from "react";
import { Row, Col, Container } from "react-bootstrap";

function PublishSection() {
  return (
    <div className="bg-publish-image py-1 mb-5">
      <Container fluid>
        <Row className="p-2 p-sm-5 m-2 my-5">
          <Col
            xs={12}
            sm={10}
            className=" ms-auto px-0  aos-init aos-animate"
            style={{ paddingLeft: 0, marginBottom: "10px" }}
          >
            <a
              href="https://www.youtube.com/watch?v=GIV-sfAva00&t=1s"
              target="_blank"
              rel="noreferrer"
              className="text-white font-header h1 fw-bolder font-x-large fst-italic"
              id="publish-with-us"
              style={{  fontVariant: "small-caps !important" }}
            >
              Publish with us
            </a>
          </Col>
          <Col
            sm={2}
            className="mt-3 px-0 mx-0"
            style={{ paddingLeft: 0, marginBottom: "10px" }}
          >
            <a
              href="https://www.youtube.com/watch?v=GIV-sfAva00&t=1s"
              target="_blank"
              rel="noreferrer"
              className="btn button-gradient bg-white rounded px-5 py-3"
              style={{ border: "1px solid #ffffff" }}
            >
              Learn More
            </a>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default PublishSection;
